/**
 * @author mll
 * @date 2021-3-3
 * @desc 场地信息查看
 */
import React from "react";
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { WizAuthority } from "../../../common";
import { Row, Col } from 'antd';
import './index.less'
let { WizContainer, modelUtils, ossFileUtils } = framework_tool
let { WizCard, WizSpin, WizTabs } = component_tool
let { Session } = utils_tool
import AppointmentCalendar from '../../siteOrder/siteOrderDetail/appointmentCalendar'

class TrainSiteLook extends WizContainer {
    componentName = 'TrainSiteLook'

    constructor(props) {
        super(props)
        const { history } = props
        let detailInfo = {};
        if (history.location && history.location.pathname === '/site/trainSite/look') {
            if (history.location && history.location.record) {
                detailInfo = history.location.record
                Session.set('trainSiteLook', detailInfo)
            } else {
                detailInfo = Session.get('trainSiteLook') || {}
            }
        }
        this.detailInfo = detailInfo || {}
        this.state = {
            detailInfo: {}
        }
    }

    _componentDidMount() {
        if (this.detailInfo.id) {
            this.doAction({
                path: 'trainSite/look',
                payload: {
                    key: "trainSiteLook",
                    apiParams: {
                        id: this.detailInfo.id || ''
                    }
                }
            });
        }
    }

    propsAndStateOnChange = {
        trainSiteLook: this._trainSiteLook.bind(this)
    }

    _trainSiteLook(nextProps, nextState) {
        let { trainSiteLook } = nextProps
        if (trainSiteLook['success']) {
            nextState.detailInfo = trainSiteLook['data']
            return true;
        } else {
            wizNotice.error(trainSiteLook['msg'] || '获取数据失败，请稍后再试')
        }
        return false;
    }


    /** 关闭查看Model*/
    handleCancel = () => this.setState({
        previewImgVisible: false
    });

    getImgInfo = (type) => {
        let record = this.detailInfo
        let datas = [];
        if (type === 'img') {
            datas = record.imgMimes
        } else if (type === 'video') {
            datas = record.videoMimes
        } else if (type === 'audio') {
            datas = record.audioMimes
        } else if (type === 'file') {
            datas = record.fileMimes
        }
        let urls = [];
        datas.forEach(element => {
            let urlOld = ossFileUtils.getOssFile(
                element.img,
                element.fileName,
                element.fileMimeType,
                element.fileSize,
                element.fileUri,
            )
            let url = urlOld.url
            url = element.fileUri ? url : constants.files.sys_img_loadingFailed;
            let fileObj = {};
            fileObj.url = url;
            fileObj.fileName = element.fileName
            fileObj.urlOld = urlOld
            fileObj.fileId = element.fileId
            urls.push(fileObj);
        });
        let show = []
        urls.forEach(e => {
            if (type === 'img') {
                show.push(<Col span={4.5} ><img height={80} width={130} style={{ margin: 5 }} src={e.url} onClick={p => this.handlePreview(e)} /></Col>)
            } else {
                show.push(<Col span={24} ><div height={80} width={130} style={{ margin: 5 }} >
                    <a href={e.url} target="_blank" style={{ color: "blue" }}>{e.fileName}</a>
                </div></Col>)
            }
        })

        return <Row type='flex' justify='start' gutter={{ xs: 4.5, sm: 16, md: 24 }}>
            {show}
        </Row>

    }


    _render() {
        const {
            name, code, trainCenterName, city, address, type, purpose, parkingSpace,
            floorSpace, seat, managerPersonName, status, fixedEquipments,
            allowOrder, auditType, remark, authInfo, id
        } = this.state.detailInfo
        let typeEnum = ['教室', '大门', '餐厅', '其他']
        let purposeEnum = ['不限制', '新产品培训', '实操培训', '岗位培训', '区域会议']
        let statusEnum = ['正常', '停止使用', '维修中']
        let fixedEquipmentsEnum = ['投影仪', '培训器具', '笔记本电脑', '灯具', '举升机']
        let allowOrderEnum = ['允许', '不允许']
        let auditTypeEnum = ['自动审核', '手动审核']
        let getFixedEquipments = (fixedEquipments) => {
            if (!checkEmpty(fixedEquipments)) { return '' }
            let f = fixedEquipments.split(',');
            if (!f || !f.length) { return '' }
            let str = ''
            f.map((_f) => { str += fixedEquipmentsEnum[_f] + '、' })
            return str.substring(0, str.length - 1)
        }
        return (
            <React.Fragment>
                <WizSpin tip={'加载中'} spinning={this.props.trainSiteLoading}>
                    <WizCard title={'场地信息'} icon='0'>
                        <Descriptions column={2}>
                            <Descriptions.Item label='场地名称'>{name}</Descriptions.Item>
                            <Descriptions.Item label='场地编号'>{code}</Descriptions.Item>
                            <Descriptions.Item label='培训中心'>{trainCenterName}</Descriptions.Item>
                            <Descriptions.Item label='城市'>{city}</Descriptions.Item>
                            <Descriptions.Item label='地址'>{address}</Descriptions.Item>
                            <Descriptions.Item label='场地应用类型'>{typeEnum[type || 0]}</Descriptions.Item>
                            <Descriptions.Item label='教室用途'>{purposeEnum[purpose || 0]}</Descriptions.Item>
                            <Descriptions.Item label='进车（数量）'>{parkingSpace || 0}</Descriptions.Item>
                            <Descriptions.Item label='座位（数量）'>{seat}</Descriptions.Item>
                            <Descriptions.Item label='教室面积'>{floorSpace}</Descriptions.Item>
                            <Descriptions.Item label='管理员'>{managerPersonName}</Descriptions.Item>
                            <Descriptions.Item label='教室状态'>{statusEnum[status || 0]}</Descriptions.Item>
                            <Descriptions.Item label='教室配置'>{getFixedEquipments(fixedEquipments)}</Descriptions.Item>
                            <Descriptions.Item label='预约设置'>{allowOrderEnum[allowOrder && allowOrder !== 0 ? 1 : allowOrder]}</Descriptions.Item>
                            <Descriptions.Item label='审核类型'>{auditTypeEnum[auditType || 0]}</Descriptions.Item>
                            <Descriptions.Item label='备注'>{remark || ''}</Descriptions.Item>
                        </Descriptions>
                    </WizCard>
                    <WizCard title={'场地信息'} icon='0'>
                        <WizTabs animated={false}>
                            <WizTabs.TabPane tab="场地受众" key={'auth'}>
                                <div className='train-site-look-auth'>
                                    <WizAuthority value={authInfo} mode='Show' showBlock={false} />
                                </div>
                            </WizTabs.TabPane>
                            <WizTabs.TabPane tab="场地预约信息" key={'info'}>
                                <AppointmentCalendar siteId={id} mode='show' />
                            </WizTabs.TabPane>
                        </WizTabs>
                    </WizCard>
                </WizSpin>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { trainSite } = state;
    const trainSiteLook = modelUtils.getModelEntity(trainSite, "trainSiteLook");
    const load = modelUtils.getLoadingState(state, ['trainSite']);
    return {
        trainSiteLook,
        ...load
    }
};

export default connect(mapStateToProps)(TrainSiteLook)
